import AccessibleParkingIcon from './AccessibleParking/Icon';
import AccessibleParkingIconHover from './AccessibleParking/IconHover';
import AddressChangeIcon from './AddressChange/Icon';
import AddressChangeIconHover from './AddressChange/IconHover';
import AddressIcon from './Address/Icon';
import AddressIconHover from './Address/IconHover';
import AdultsIcon from './Adults/Icon';
import AdultsIconHover from './Adults/IconHover';
import AssistiveTechnologyIcon from './AssistiveTechnology/Icon';
import AssistiveTechnologyIconHover from './AssistiveTechnology/IconHover';
import BenefitsIcon from './Benefits/Icon';
import BenefitsIconHover from './Benefits/IconHover';
import BinDayIcon from './BinDay/Icon';
import BinDayIconHover from './BinDay/IconHover';
import BinsIcon from './Bins/Icon';
import BinsIconHover from './Bins/IconHover';
import BirthCertificateIcon from './BirthCertificate/Icon';
import BirthCertificateIconHover from './BirthCertificate/IconHover';
import BirthsIcon from './Births/Icon';
import BirthsIconHover from './Births/IconHover';
import BollardIcon from './Bollard/Icon';
import BollardIconHover from './Bollard/IconHover';
import BulkWasteIcon from './BulkWaste/Icon';
import BulkWasteIconHover from './BulkWaste/IconHover';
import BusIcon from './Bus/Icon';
import BusIconHover from './Bus/IconHover';
import BusPassIcon from './BusPass/Icon';
import BusPassIconHover from './BusPass/IconHover';
import BusinessIcon from './Business/Icon';
import BusinessIconHover from './Business/IconHover';
import CareersIcon from './Careers/Icon';
import CareersIconHover from './Careers/IconHover';
import CashIcon from './Cash/Icon';
import CashIconHover from './Cash/IconHover';
import CatalogueIcon from './Catalogue/Icon';
import CatalogueIconHover from './Catalogue/IconHover';
import CeremonyIcon from './Ceremony/Icon';
import CeremonyIconHover from './Ceremony/IconHover';
import CharityIcon from './Charity/Icon';
import CharityIconHover from './Charity/IconHover';
import ChildrenIcon from './Children/Icon';
import ChildrenIconHover from './Children/IconHover';
import ComputerIcon from './Computer/Icon';
import ComputerIconHover from './Computer/IconHover';
import CondolenceBookIcon from './CondolenceBook/Icon';
import CondolenceBookIconHover from './CondolenceBook/IconHover';
import CookingIcon from './Cooking/Icon';
import CookingIconHover from './Cooking/IconHover';
import CouncilIcon from './Council/Icon';
import CouncilIconHover from './Council/IconHover';
import CouncilTaxIcon from './CouncilTax/Icon';
import CouncilTaxIconHover from './CouncilTax/IconHover';
import CovidIcon from './Covid/Icon';
import CovidIconHover from './Covid/IconHover';
import CultureNorthIcon from './CultureNorth/Icon';
import CultureNorthIconHover from './CultureNorth/IconHover';
import CultureWestIcon from './CultureWest/Icon';
import CultureWestIconHover from './CultureWest/IconHover';
import DeathCertificateIcon from './DeathCertificate/Icon';
import DeathCertificateIconHover from './DeathCertificate/IconHover';
import DemocracyIcon from './Democracy/Icon';
import DemocracyIconHover from './Democracy/IconHover';
import DogFoulingIcon from './DogFouling/Icon';
import DogFoulingIconHover from './DogFouling/IconHover';
import DOLSIcon from './DOLS/Icon';
import DOLSIconHover from './DOLS/IconHover';
import EbookIcon from './Ebook/Icon';
import EbookIconHover from './Ebook/IconHover';
import EditIcon from './Edit/Icon';
import EditIconHover from './Edit/IconHover';
import EnvironmentIcon from './Environment/Icon';
import EnvironmentIconHover from './Environment/IconHover';
import EventsIcon from './Events/Icon';
import EventsIconHover from './Events/IconHover';
import FinanceIcon from './Finance/Icon';
import FinanceIconHover from './Finance/IconHover';
import FlowerIcon from './Flower/Icon';
import FlowerIconHover from './Flower/IconHover';
import FlyTipIcon from './FlyTip/Icon';
import FlyTipIconHover from './FlyTip/IconHover';
import FoodWasteIcon from './FoodWaste/Icon';
import FoodWasteIconHover from './FoodWaste/IconHover';
import GiveNoticeIcon from './GiveNotice/Icon';
import GiveNoticeIconHover from './GiveNotice/IconHover';
import GovUKIcon from './GovUK/Icon';
import GovUKIconHover from './GovUK/IconHover';
import GraffitiIcon from './Graffiti/Icon';
import GraffitiIconHover from './Graffiti/IconHover';
import HighwayIcon from './Highway/Icon';
import HighwayIconHover from './Highway/IconHover';
import HouseMoneyIcon from './HouseMoney/Icon';
import HouseMoneyIconHover from './HouseMoney/IconHover';
import HousingIcon from './Housing/Icon';
import HousingIconHover from './Housing/IconHover';
import IndependenceIcon from './Independence/Icon';
import IndependenceIconHover from './Independence/IconHover';
import LibrariesIcon from './Libraries/Icon';
import LibrariesIconHover from './Libraries/IconHover';
import KeepingHealthyIcon from './KeepingHealthy/Icon';
import KeepingHealthyIconHover from './KeepingHealthy/IconHover';
import LitterIcon from './Litter/Icon';
import LitterIconHover from './Litter/IconHover';
import LookingAfterYourselfIcon from './LookingAfterYourself/Icon';
import LookingAfterYourselfIconHover from './LookingAfterYourself/IconHover';
import MapPinIcon from './MapPin/Icon';
import MapPinIconHover from './MapPin/IconHover';
import MemberIcon from './Member/Icon';
import MemberIconHover from './Member/IconHover';
import MentalHealth from './MentalHealth/Icon';
import MentalHealthIconHover from './MentalHealth/IconHover';
import MissedBinIcon from './MissedBin/Icon';
import MissedBinIconHover from './MissedBin/IconHover';
import NewIcon from './New/Icon';
import NewIconHover from './New/IconHover';
import OccupationalTherapyIcon from './OccupationalTherapy/Icon';
import OccupationalTherapyIconHover from './OccupationalTherapy/IconHover';
import ParkEventIcon from './ParkEvent/Icon';
import ParkEventIconHover from './ParkEvent/IconHover';
import ParkingIcon from './Parking/Icon';
import ParkingIconHover from './Parking/IconHover';
import ParkingTicketIcon from './ParkingTicket/Icon';
import ParkingTicketIconHover from './ParkingTicket/IconHover';
import PayIcon from './Pay/Icon';
import PayIconHover from './Pay/IconHover';
import PhonePayIcon from './PhonePay/Icon';
import PhonePayIconHover from './PhonePay/IconHover';
import PlanningIcon from './Planning/Icon';
import PlanningIconHover from './Planning/IconHover';
import PotholeIcon from './Pothole/Icon';
import PotholeIconHover from './Pothole/IconHover';
import PreventingFallsIcon from './PreventingFalls/Icon';
import PreventingFallsIconHover from './PreventingFalls/IconHover';
import ProtectIcon from './Protect/Icon';
import ProtectIconHover from './Protect/IconHover';
import RatePayIcon from './RatePay/Icon';
import RatePayIconHover from './RatePay/IconHover';
import RegisterBirthIcon from './RegisterBirth/Icon';
import RegisterBirthIconHover from './RegisterBirth/IconHover';
import RegisterDeathIcon from './RegisterDeath/Icon';
import RegisterDeathIconHover from './RegisterDeath/IconHover';
import ReportIcon from './Report/Icon';
import ReportIconHover from './Report/IconHover';
import RestrictIcon from './Restrict/Icon';
import RestrictIconHover from './Restrict/IconHover';
import RoadsIcon from './Roads/Icon';
import RoadsIconHover from './Roads/IconHover';
import RoadWorksIcon from './RoadWorks/Icon';
import RoadWorksIconHover from './RoadWorks/IconHover';
import RoyalWebsiteIcon from './RoyalWebsite/Icon';
import RoyalWebsiteIconHover from './RoyalWebsite/IconHover';
import SafetyIcon from './Safety/Icon';
import SafetyIconHover from './Safety/IconHover';
import SchoolAdmissionsIcon from './SchoolAdmissions/Icon';
import SchoolAdmissionsIconHover from './SchoolAdmissions/IconHover';
import SchoolsIcon from './Schools/Icon';
import SchoolsIconHover from './Schools/IconHover';
import SendIcon from './SEND/Icon';
import SendIconHover from './SEND/IconHover';
import SinglePersonIcon from './SinglePerson/Icon';
import SinglePersonIconHover from './SinglePerson/IconHover';
import SportsIcon from './Sports/Icon';
import SportsIconHover from './Sports/IconHover';
import ValuationIcon from './Valuation/Icon';
import ValuationIconHover from './Valuation/IconHover';
import VenueIcon from './Venue/Icon';
import VenueIconHover from './Venue/IconHover';
import WasteChecklistIcon from './WasteChecklist/Icon';
import WasteChecklistIconHover from './WasteChecklist/IconHover';
import WasteSortingIcon from './WasteSorting/Icon';
import WasteSortingIconHover from './WasteSorting/IconHover';

let components = {
  accessibleparking: AccessibleParkingIcon,
  accessibleparkingHover: AccessibleParkingIconHover,
  adults: AdultsIcon,
  adultsHover: AdultsIconHover,
  addresschange: AddressChangeIcon,
  addresschangeHover: AddressChangeIconHover,
  address: AddressIcon,
  addressHover: AddressIconHover,
  assistivetechnology: AssistiveTechnologyIcon,
  assistivetechnologyHover: AssistiveTechnologyIconHover,
  benefits: BenefitsIcon,
  benefitsHover: BenefitsIconHover,
  binday: BinDayIcon,
  bindayHover: BinDayIconHover,
  bins: BinsIcon,
  binsHover: BinsIconHover,
  birthcertificate: BirthCertificateIcon,
  birthcertificateHover: BirthCertificateIconHover,
  births: BirthsIcon,
  birthsHover: BirthsIconHover,
  bollard: BollardIcon,
  bollardHover: BollardIconHover,
  bulkwaste: BulkWasteIcon,
  bulkwasteHover: BulkWasteIconHover,
  bus: BusIcon,
  busHover: BusIconHover,
  buspass: BusPassIcon,
  buspassHover: BusPassIconHover,
  business: BusinessIcon,
  businessHover: BusinessIconHover,
  careers: CareersIcon,
  careersHover: CareersIconHover,
  cash: CashIcon,
  cashHover: CashIconHover,
  catalogue: CatalogueIcon,
  catalogueHover: CatalogueIconHover,
  ceremony: CeremonyIcon,
  ceremonyHover: CeremonyIconHover,
  charity: CharityIcon,
  charityHover: CharityIconHover,
  children: ChildrenIcon,
  childrenHover: ChildrenIconHover,
  computer: ComputerIcon,
  computerHover: ComputerIconHover,
  condolenceBook: CondolenceBookIcon,
  condolenceBookHover: CondolenceBookIconHover,
  cooking: CookingIcon,
  cookingHover: CookingIconHover,
  council: CouncilIcon,
  councilHover: CouncilIconHover,
  counciltax: CouncilTaxIcon,
  counciltaxHover: CouncilTaxIconHover,
  covid: CovidIcon,
  covidHover: CovidIconHover,
  culturenorth: CultureNorthIcon,
  culturenorthHover: CultureNorthIconHover,
  culturewest: CultureWestIcon,
  culturewestHover: CultureWestIconHover,
  deathcertificate: DeathCertificateIcon,
  deathcertificateHover: DeathCertificateIconHover,
  democracy: DemocracyIcon,
  democracyHover: DemocracyIconHover,
  dogfouling: DogFoulingIcon,
  dogfoulingHover: DogFoulingIconHover,
  dols: DOLSIcon,
  dolsHover: DOLSIconHover,
  ebook: EbookIcon,
  ebookHover: EbookIconHover,
  edit: EditIcon,
  editHover: EditIconHover,
  environment: EnvironmentIcon,
  environmentHover: EnvironmentIconHover,
  events: EventsIcon,
  eventsHover: EventsIconHover,
  finance: FinanceIcon,
  financeHover: FinanceIconHover,
  flower: FlowerIcon,
  flowerHover: FlowerIconHover,
  flytip: FlyTipIcon,
  flytipHover: FlyTipIconHover,
  foodwaste: FoodWasteIcon,
  foodwasteHover: FoodWasteIconHover,
  givenotice: GiveNoticeIcon,
  givenoticeHover: GiveNoticeIconHover,
  govUK: GovUKIcon,
  govUKHover: GovUKIconHover,
  graffiti: GraffitiIcon,
  graffitiHover: GraffitiIconHover,
  highway: HighwayIcon,
  highwayHover: HighwayIconHover,
  housemoney: HouseMoneyIcon,
  housemoneyHover: HouseMoneyIconHover,
  housing: HousingIcon,
  housingHover: HousingIconHover,
  independence: IndependenceIcon,
  independenceHover: IndependenceIconHover,
  keepinghealthy: KeepingHealthyIcon,
  keepinghealthyHover: KeepingHealthyIconHover,
  libraries: LibrariesIcon,
  librariesHover: LibrariesIconHover,
  litter: LitterIcon,
  litterHover: LitterIconHover,
  lookingafteryourself: LookingAfterYourselfIcon,
  lookingafteryourselfHover: LookingAfterYourselfIconHover,
  mappin: MapPinIcon,
  mappinHover: MapPinIconHover,
  member: MemberIcon,
  memberHover: MemberIconHover,
  mentalhealth: MentalHealth,
  mentalhealthHover: MentalHealthIconHover,
  missedbin: MissedBinIcon,
  missedbinHover: MissedBinIconHover,
  new: NewIcon,
  newHover: NewIconHover,
  occupationaltherapy: OccupationalTherapyIcon,
  occupationaltherapyHover: OccupationalTherapyIconHover,
  parkevent: ParkEventIcon,
  parkeventHover: ParkEventIconHover,
  parking: ParkingIcon,
  parkingHover: ParkingIconHover,
  parkingticket: ParkingTicketIcon,
  parkingticketHover: ParkingTicketIconHover,
  pay: PayIcon,
  payHover: PayIconHover,
  phonepay: PhonePayIcon,
  phonepayHover: PhonePayIconHover,
  planning: PlanningIcon,
  planningHover: PlanningIconHover,
  pothole: PotholeIcon,
  potholeHover: PotholeIconHover,
  preventingfalls: PreventingFallsIcon,
  preventingfallsHover: PreventingFallsIconHover,
  protect: ProtectIcon,
  protectHover: ProtectIconHover,
  ratepay: RatePayIcon,
  ratepayHover: RatePayIconHover,
  registerbirth: RegisterBirthIcon,
  registerbirthHover: RegisterBirthIconHover,
  registerdeath: RegisterDeathIcon,
  registerdeathHover: RegisterDeathIconHover,
  report: ReportIcon,
  reportHover: ReportIconHover,
  restrict: RestrictIcon,
  restrictHover: RestrictIconHover,
  roads: RoadsIcon,
  roadsHover: RoadsIconHover,
  roadworks: RoadWorksIcon,
  roadworksHover: RoadWorksIconHover,
  royalWebsite: RoyalWebsiteIcon,
  royalWebsiteHover: RoyalWebsiteIconHover,
  safety: SafetyIcon,
  safetyHover: SafetyIconHover,
  schooladmissions: SchoolAdmissionsIcon,
  schooladmissionsHover: SchoolAdmissionsIconHover,
  schools: SchoolsIcon,
  schoolsHover: SchoolsIconHover,
  send: SendIcon,
  sendHover: SendIconHover,
  singleperson: SinglePersonIcon,
  singlepersonHover: SinglePersonIconHover,
  sports: SportsIcon,
  sportsHover: SportsIconHover,
  valuation: ValuationIcon,
  valuationHover: ValuationIconHover,
  venue: VenueIcon,
  venueHover: VenueIconHover,
  wastechecklist: WasteChecklistIcon,
  wastechecklistHover: WasteChecklistIconHover,
  wastesorting: WasteSortingIcon,
  wastesortingHover: WasteSortingIconHover,
};

export default components;
